import { CampaignRoute } from '../constants';
import { sessionIdVar } from '../state/session';

export function buildRouteUrl(route: string): string {
  return `${route}?sessionId=${sessionIdVar()}`;
}

export function buildCampaignRouteUrl(route: CampaignRoute) {
  return route.replace('/', '');
}
